export { ExameGenerico } from './ExameGenerico'
